// Palet & data brand diambil dari aplikasi Pangkasin (barbershop.carroo.my.id)
// sumber: resources/css/app.css (palet neo-brutalism) + auth/login.blade.php

export const C = {
  ink: "#1a1a2e",
  ink900: "#16213e",
  ink800: "#0f3460",
  ink600: "#53687e",
  ink400: "#8e9aaf",
  ink200: "#d6d6d6",
  ink100: "#e8e8e8",
  ink50: "#f0f0f0",
  cream: "#fef9ef",
  white: "#ffffff",
  yellow: "#ffde59",
  pink: "#ff6b9d",
  blue: "#4ecdc4",
  purple: "#a855f7",
  orange: "#ff9f43",
  lime: "#c7f464",
  red: "#ff4757",
  ok: "#2ed573",
} as const;

export const FONT = "Onest, 'DejaVu Sans', Arial, sans-serif";

export const B = 4; // ketebalan border neo-brutalism
export const bd = (w = B) => `${w}px solid ${C.ink}`;

export const INFO = {
  name: "Pangkasin",
  sub: "Management System",
  tagline: "Sistem kasir & manajemen barbershop",
  wa: "0895-3970-73311",
  waLink: "wa.me/62895397073311",
  site: "barbershop.carroo.my.id",
};

// harga layanan nyata dari DemoSeeder aplikasinya
export const SERVICES = [
  { name: "Potong Rambut", price: 35000 },
  { name: "Potong + Keramas", price: 50000 },
  { name: "Cukur Jenggot", price: 20000 },
  { name: "Creambath", price: 60000 },
];

export const rp = (n: number) => "Rp" + Math.round(n).toLocaleString("id-ID");

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
